// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';
import { HelmetProvider } from '/Users/xieyongying/frontend-project/benai-admin/benai-admin/node_modules/.pnpm/@umijs+renderer-react@4.6.5_react-dom@19.2.1_react@19.2.1__react@19.2.1/node_modules/@umijs/renderer-react';
import { context } from './helmetContext';

export const innerProvider = (container) => {
  return React.createElement(HelmetProvider, { context }, container);
}
